module.exports = __webpack_public_path__ + "img/dr-azim.ac4ead97.png";